import { render, staticRenderFns } from "./MoreVipEntranceButton.vue?vue&type=template&id=3ce4fd6a&scoped=true&"
import script from "./MoreVipEntranceButton.vue?vue&type=script&lang=ts&"
export * from "./MoreVipEntranceButton.vue?vue&type=script&lang=ts&"
import style0 from "./MoreVipEntranceButton.scss?vue&type=style&index=0&id=3ce4fd6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce4fd6a",
  null
  
)

export default component.exports